export default function (type) {
  try {
    return window.grecaptcha.enterprise.execute(process.env.VUE_APP_RECATCHA, { action: type })
  } catch(error) {
    console.log(error, 'error')
    return Promise.resolve('')
  }
}